export default __webpack_public_path__ + "static/Marketplace-fees-bddbb3b0ed5f8a6896bdb2a944316d3d.webp";